import { FormControlLabel, FormControlLabelProps, Switch } from '@mui/material';
import { FC } from 'react';

interface LabelSwitchProps extends Omit<FormControlLabelProps, 'control'> {};

const LabelSwitch: FC<LabelSwitchProps> = (props) => <FormControlLabel control={<Switch />} {...props} />;

export default LabelSwitch;
